import { Capacitor } from "@capacitor/core";

// Cognito User Pool configuration for NephroTrax.
// These are not secrets — a Cognito App Client ID for a public (no-secret)
// client is safe to ship in frontend JS, same as Auth0's clientId was.

export const COGNITO_CONFIG = {
  region: process.env.REACT_APP_COGNITO_REGION || "us-east-1",
  userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID || "us-east-1_ZVGNYW5Ar",
  clientId: process.env.REACT_APP_COGNITO_CLIENT_ID || "7jf664gjjei8ok1he8nuuche2d",
  hostedUiDomain:
    process.env.REACT_APP_COGNITO_DOMAIN ||
    "nephrotrax-auth.auth.us-east-1.amazoncognito.com",
};

function isNativeApp() {
  const isNative = Capacitor.isNativePlatform();
  const platform = Capacitor.getPlatform();
  return isNative || platform === "ios" || platform === "android";
}

// Redirect URI used for both the OAuth authorization-code flow (Apple/Google)
// and as the return point after the Hosted UI logout endpoint. Mirrors the
// native-vs-web branching that was already used for Auth0's redirect_uri.
export function getRedirectUri() {
  return isNativeApp()
    ? "com.verainsight.nephrotrax://callback"
    : window.location.origin + "/auth/callback";
}

export function getLogoutRedirectUri() {
  return isNativeApp() ? "com.verainsight.nephrotrax://callback" : window.location.origin + "/";
}
